import axios from 'axios'
import { Modal, Message, Spin } from 'view-design'
import cookie from 'vue-cookies';
import vue from "../main"
import util from "@/libs/util"

var root = process.env.API_URL;
var spinHideTimeout = {}

const CancelToken = axios.CancelToken;

const ajaxRequest = axios.create({
  baseURL: root,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})
// 考虑到后续请求取消白屏动画的情况可能增多干脆封装一下
const chatIgnoreList = [
  "/message_callback_by_admin",
  "/set_chatroom_block_status",
  "/get_chatroom_block_status",
  "/list_chat_room_users_status",
  "/list_chat_room_message_history",
  "/query_tags",
  "query_sport_items",
  "/get_smart_tag_list",
  "/get_vod_subtitles",
  "/get_snapshot_sprite_image_list",
  "/add_vod_watch_duration",
  "/get_vod_watch_duration",
  "add_user_new_function_teaching",
  "/query_product"
]
const refreshIgnoreList = [...chatIgnoreList, "/ping", "/get_notice_list_by_user", "/create_or_update_bookmark", "/list_bookmark", "/list_session_question", "/create_or_update_question", "/delete_answer", "/create_or_update_answer", "/delete_question", "/generate_user_qrcode", "/get_online_users_by_session", "/save_vod_chapter_log", "/list_answer_by_question", "/get_vod_play_urls", "/add_action_log", "/get_user_info", "/list_bookmark", "/get_vod_play_urls", "/get_vod_chapter_list", "/add_integral"]

function refreshIgnore(url) {
  // let flag = true
  // refreshIgnoreList.forEach(i => {
  //   flag = flag && request.url.indexOf(i) < 0
  // })
  return refreshIgnoreList.every(item => url.indexOf(item) < 0)
  // return flag
}
ajaxRequest.interceptors.request.use(
  request => {
    if (refreshIgnore(request.url)) {
      vue.$store.commit("add_ajax_spin")
      clearTimeout(spinHideTimeout)
      Spin.show();
    }
    // console.log(request, "xxxxxx")
    // req.cancelToken = new CancelToken(cancel => {
    //   let url = req.url
    //   let str = url.split('/')
    //   str = Array.from(new Set(str))
    //   let index = str.length - 1
    //   let funName = str[index]
    //   // vue.$store.commit("setCancel", { cancel, funName: funName })
    // });

    if (request.url.indexOf("authentication") < 0 && request.url.indexOf("get_user_by_token") < 0) {
      let user_info = $cookies.get("userLoginInfo") || {};
      // console.log(user_info, "user_info")
      request.headers["Token"] = vue.$store.getters.kls_user_session || user_info.session_key
    }

    return request;
  },
  error => {

    console.info(error);
    return Promise.reject(error.response.data)
  }
)
ajaxRequest.interceptors.response.use(
  async res => {
    if (refreshIgnore(res.config.url)) {
      vue.$store.commit("sub_ajax_spin")
      let ajax_count = vue.$store.getters.get_ajax_count
      if (ajax_count <= 0) {
        spinHideTimeout = setTimeout(() => {
          Spin.hide();
        }, 250)
      }
    }
    // console.log(res)
    if (res.data.unauthorized && res.data.unauthorized == 401) {
      vue.$store.commit("clearUserInfo")
      cookie.keys().forEach(o => cookie.remove(o));
      location.href = "/";
      return;
    }

    var data = res.data;
    //如果返回的是BLOB的内容，则直接返回
    if (res.request.responseType == "blob") {
      if (data.type == "application/json") {
        data = await data.text();
        console.info(data);
        data = JSON.parse(data);
      } else {
        return res.data;
      }
    }

    // //如果返回的是BLOB的内容，则直接返回
    // if(res.data.type && res.data.type == "application/octet-stream"){
    //   return res.data;
    // }

    if (data.err_code == 0) {
      return res.data;
    } else {
      // console.log(res,"sssssssssssssssssssss")
      if (data.err_message == "No Video") {
        console.warn(data.err_message)
      } else if (res.config.url == "user/ping?session_id=") {
        console.warn(data.err_message)
      } else {
        util.showError(data.err_message)
      }

      return Promise.reject(data)
    }
  },
  error => {
    console.info(error);
    vue.$store.commit("sub_ajax_spin")
    let ajax_count = vue.$store.getters.get_ajax_count
    if (ajax_count <= 0) {
      spinHideTimeout = setTimeout(() => {
        Spin.hide();
      }, 250)
    }
    if (error.response.status === 504) {
      Message.error("请求超时")
    } else {

      // Modal.error({
      //   title: "SYSTEM ERROR",
      //   content: JSON.stringify(error.response.data) + "<br/>YOU CAN TRY TO RELOAD THIS PAGE OR CONTACT WITH ADMIN",
      //   okText: "OK",
      // });
    }
    return Promise.reject(error)
    // Modal.error({
    //   title: "SYSTEM ERROR",
    //   content: error + "<br/>YOU CAN TRY TO RELOAD THIS PAGE OR CONTACT WITH ADMIN",
    //   okText: "OK",
    // });
  }
)

export default ajaxRequest



// WEBPACK FOOTER //
// ./src/api/ajax.js